module.exports = __webpack_public_path__ + "img/logo_large.9eb6b27d.png";